import {useState } from 'react'
import { useSelector , useDispatch } from 'react-redux';
import { fetchWithDefaults } from '../../config/fetchDefault';
import { setDoNotContactState } from '../../features/doNotContactSlice';
import { setTableUpdate } from '../../features/leadTableFiltersSlice';
const DoNotContact = ({maxList}) => {

    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const [popupVisible , setPopVisible] = useState(false);
    const [optionSelected , setOptionSelected] = useState('')
    const [color , setColor] = useState('#F95951')

    const dispatch = useDispatch()
    const handlePopClose = (e)=>{
     e.preventDefault();
     setPopVisible(false);
     setOptionSelected('');
     setColor('#F95951')
    }
    const handleDNC = async (e) => {
     e.preventDefault();
        try {
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
             lead: leadsAlldata?.lead_id,
             dnc_method: `${optionSelected}`,
            }),
          };

          const response = await fetchWithDefaults(`/dnc/doNotContact`, requestOptions);

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const jsonData = await response.json();
           maxList()

          dispatch(setDoNotContactState(true))
          dispatch(setTableUpdate(true))
        } catch (error) {
          alert('Something went wrong please try again')
        }
    }
  return (
    <>
   <div className='dnc-main' onClick={(e)=> {setColor('#953531'); setPopVisible(true);}} onMouseEnter={(e)=> {if(!popupVisible) setColor('#C74741')}} onMouseLeave={(e)=> {if(!popupVisible) setColor('#F95951')}}>
      <span style={{fontSize : '14px' , fontWeight : 400}}>{`Did ${leadsAlldata.borrower_first} ${leadsAlldata.borrower_last} ask not to be contacted?`}</span>
      <svg style={{marginLeft : '7px'}} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
       <path d="M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
     </svg>
      <span style={{color : color, cursor: 'pointer'}} className='dnc-text'>Mark Lead As Do Not Contact</span>
    </div>

    {popupVisible && <div className="overlay">
    <div className="popup">
     <div className="dncCloseWrapper" onClick={handlePopClose}>
      <svg className="dncCloseIcon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
         <path d="M18 6L6 18M6 6L18 18" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </div>
      <h2 className='popup-heading'>Mark this lead as Do Not Contact (DNC)?</h2>
        <p className='dnc-para'>This will remove the lead from your account. This action cannot be undone.</p>
        <label className='dnc-label'><input  className='dnc-radio' type="radio" name='radio' value={'text'} onClick={(e)=> setOptionSelected(e.target.value)}/>{` ${leadsAlldata.borrower_first} ${leadsAlldata.borrower_last} opted out by text`}</label>
        <label className='dnc-label'><input className='dnc-radio' type="radio" name='radio' value={'phone'} onClick={(e)=> setOptionSelected(e.target.value)}/>{` ${leadsAlldata.borrower_first} ${leadsAlldata.borrower_last} opted out by phone`}</label>
      <div className ="actions">
         <button className="btn cancel-btn" onClick={handlePopClose}>Cancel</button>
         <button className={`btn ${optionSelected ? 'enable' : 'disable'}`} onClick={handleDNC}>Yes, Mark as Do Not Contact</button>
      </div>
    </div>
  </div>}
    </>
  )
}

export default DoNotContact